import { i18nProviderFactory } from '@40seas/frontend/libs/providers';
import merge from 'lodash/merge';
import cnLocale from 'ra-language-chinese';
import enLocale from 'ra-language-english';

import * as customChineseLocale from '../../assets/locale/cn_locale.json';
import * as customEnglishLocale from '../../assets/locale/en_locale.json';

const en = merge(enLocale, customEnglishLocale);
const cn = merge(structuredClone(en), cnLocale, customChineseLocale);

export const i18nProvider = i18nProviderFactory({ en, cn });
